import L from 'leaflet'
import {
  aggregateClusterEntityColorCounts,
  countClusterEntities,
} from '../shared/marker-cluster-color.js'
import {
  buildDonutClusterHtml,
  resolveDonutClusterSizePx,
} from '../shared/donut-cluster-icon.js'
import { leafletMarkerMetadata } from './leaflet-marker-metadata.js'
import type { MarkerCluster } from 'leaflet.markercluster'

export function createLeafletDonutClusterIconCreateFunction(): (
  cluster: MarkerCluster
) => L.DivIcon {
  return (cluster) => {
    const childMarkers = cluster.getAllChildMarkers()
    const mapMarkers = childMarkers
      .map((marker) => leafletMarkerMetadata.get(marker))
      .filter((marker): marker is NonNullable<typeof marker> => marker != null)
    const total = countClusterEntities(mapMarkers)
    const counts = aggregateClusterEntityColorCounts(mapMarkers)
    const size = resolveDonutClusterSizePx(total)
    const html = buildDonutClusterHtml(counts, total, size)
    return L.divIcon({
      html,
      className: 'gpx-leaflet-donut-cluster',
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    })
  }
}
